import { Message, IMessage, MessageTextConverter } from "./Message";

export interface IListReplyMessage extends IMessage {

    Reply: IListMessageReplyItem;

}

export interface IListMessageReplyItem {
    Id: string;
    Title: string;
}

export const ListReplyMessage = (props: IListReplyMessage) => {




    return <Message  {...props}>{MessageTextConverter.parse(props.Reply.Title)}</Message>

}